/* CELLFIE site wide behaviour. Loaded on every page from cellfie-global. */
(function () {
  'use strict';

  /* Images inside a dialog that was display:none when the page parsed can sit
     unloaded after the dialog opens. Nudge them the moment it opens. */
  function wakeImages(scope) {
    var imgs = scope.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.complete && img.naturalWidth) continue;
      img.loading = 'eager';
      var src = img.getAttribute('src');
      if (src) { img.setAttribute('src', src); }
    }
  }

  var pending = null;
  new MutationObserver(function () {
    window.clearTimeout(pending);
    pending = window.setTimeout(function () {
      var open = document.querySelectorAll('dialog[open]');
      for (var i = 0; i < open.length; i++) wakeImages(open[i]);
    }, 40);
  }).observe(document.documentElement, {
    attributes: true, subtree: true, childList: true, attributeFilter: ['open']
  });

  /* The header row is declared sticky, but its containing block is the header
     group, which is only as tall as the header itself, so it stuck for zero
     pixels and scrolled away. The group is the sticky element instead, pulled
     up by the height of the announcement bar so that bar still scrolls off and
     the nav row is what stays pinned. */
  function measureAnnouncement() {
    var group = document.getElementById('header-group');
    if (!group) return;
    var bar = group.firstElementChild;
    var nav = document.querySelector('.cf-top');
    if (!bar || !nav || bar.contains(nav)) {
      document.documentElement.style.setProperty('--cf-ann-h', '0px');
      return;
    }
    var h = Math.round(bar.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--cf-ann-h', h + 'px');
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    measureAnnouncement();
    window.setTimeout(measureAnnouncement, 400);
    if ('ResizeObserver' in window) {
      var group = document.getElementById('header-group');
      if (group && group.firstElementChild) {
        new ResizeObserver(measureAnnouncement).observe(group.firstElementChild);
      }
    } else {
      window.addEventListener('resize', measureAnnouncement, { passive: true });
    }
  });
})();
